'use strict';

import angular from 'angular';
import template from './modal.pug';

const MemFeeAmtModalSvc = [
  'ModalSvc',
  'LoaderSvc',
  'DatetimeSvc',
  'MemTypeSvc',
  'MemFeeSvc',
  function(
    ModalSvc,
    LoaderSvc,
    DatetimeSvc,
    MemTypeSvc,
    MemFeeSvc
  ) {
    /**
     * Opens the member Modal
     * @param  {Object} currentAmounts
     * @param  {string} groupId
     * @param  {string} personId
     * @return {Object}
     */
    function open(currentMemFee, amountType, groupId) {
      // append all memberTypeIds for both amount types

      var amountTypesArray = ['amounts', 'adjustments'];
      for(var i in amountTypesArray) {
        var at = amountTypesArray[i];
        currentMemFee[at].map(DatetimeSvc.getFormDateRange);
        currentMemFee[at].map(function(a) {
          a.formAmount = Number(a.amount) / 100;
          return a;
        });
      }

      // copy current amounts value for updates
      var amountsvm = angular.copy(currentMemFee[amountType]);

      var modalvm = {
        currentMemFee,
        amountsvm
      };
      var modalInstance;

      //////////////////////////////////////////////////////////////////////////
      ///  Edit Amount Date Ranges
      //////////////////////////////////////////////////////////////////////////
      function changeStart(item) {
        var formStart = new Date(item.formStart);
        var formEnd;
        // reset end if start is updated
        if(item.formEnd) { formEnd = new Date(item.formEnd); }
        if(formEnd && formEnd < formStart) { item.formEnd = null; }
      }

      function clearEnd(item) {
        item.formEnd = null;
        modalvm.editformvm.$setDirty();
      }

      function addAmount() {
        amountsvm.push({});
      }

      function removeAmount(index) {
        amountsvm.splice(index, 1);
        modalvm.editformvm.$setDirty();
      }

      MemTypeSvc.getDefinedFor({groupId}).$promise
        .then(function(mt) {
        // option to apply price to  all member types
          mt.push({id: null, name: 'All'});
          modalvm.memberTypes = mt;
        });

      /**
       * AngularUI Datepicker
       * NOTE: can open multiple datepickers at a time
       */
      modalvm.dateFormat = 'M/d/yyyy';
      function openDatePick($event, amt, dateType) {
        $event.preventDefault();
        $event.stopPropagation();
        amt[dateType + 'Open'] = true;
      }

      //////////////////////////////////////////////////////////////////////////
      ///  Submit Amounts Updates
      //////////////////////////////////////////////////////////////////////////
      function onSubmit() {
        modalvm.submitted = true;
        if(modalvm.editformvm.$pristine) { return modalInstance.close(); }
        if(modalvm.editformvm.$invalid) { return; }

        LoaderSvc.start();

        // convert form values back for submission
        amountsvm.map(DatetimeSvc.setDatesBasedOnForm);
        amountsvm.map(function(a) {
          a.amount = String(Math.round(a.formAmount * 100));
          return a;
        });
        var editMemFee = angular.copy(currentMemFee);
        editMemFee[amountType] = amountsvm;

        var params = {groupId: currentMemFee.toGroup.id,
          id: currentMemFee.id};
        return MemFeeSvc.update(params, editMemFee).$promise
          .then(function() {
            currentMemFee[amountType] = editMemFee[amountType];
            LoaderSvc.stopSuccess('Member Dues/Fee Amounts Updated');
            modalInstance.close(modalvm.groups);
          })
          .catch(function(e) {
            LoaderSvc.stopError('System Error: ' + e);
          });
      }

      function onCancel() {
        modalInstance.dismiss();
      }

      //////////////////////////////////////////////////////////////////////////
      ///  Set Modal Scope
      //////////////////////////////////////////////////////////////////////////
      var modalScope = {modalvm: angular.extend(modalvm,
        {
          dismissable: true,
          // edit groups
          changeStart, clearEnd, addAmount, removeAmount, openDatePick,
          // modal settings
          title: 'Edit Amounts',
          buttons: [
            {classes: 'btn-primary', text: 'Update Amounts', click: onSubmit},
            {classes: 'btn-default', text: 'Close', click: onCancel}
          ]
        })
      };

      var options = {size: 'lg', template};

      modalInstance = ModalSvc.open(modalScope, options);
      return modalInstance.result;
    }

    // Public API here
    return {
      open
    };
  }
];

export default MemFeeAmtModalSvc;
